export default __webpack_public_path__ + "static/media/Karnataka-Northern-diocese.dc399554.png";